import { HardhatPersonnelSVG } from "./HardhatPersonnelSVG";
export default HardhatPersonnelSVG;
